import { ReactNode } from 'react';
import * as React from 'react';
import { Box, Icon, Text } from '@qga/roo-ui/components';
import styled from '@emotion/styled';

export interface TimelineItemProps {
  iconName?: string | undefined;
  iconColor?: string | undefined;
  iconProps?: Object | undefined;
  state: 'pending' | 'completed';
  title: string | ReactNode;
  description: string | ReactNode;
}

const TimelineBox = styled(Box)`
  & > .timeline-box:last-child > .timeline-item-box {
    border-left: 2px solid transparent;
    padding-bottom: 0px;
  }

  .with-icon:not(:first-of-type) {
    margin-top: -8px;
  }
`;

const ItemBox = styled(Box)<{ borderColor: string }>`
  border-left: 2px solid ${(props) => props.borderColor};
  padding-bottom: 24px;
`;

export const ItemIcon = styled(Icon)<{ bg?: string; ml?: string }>`
  border: 1px solid white;
  border-radius: 12px;
  background: ${(props) => props.bg || 'white'};
  margin-left: ${(props) => props.ml || '-13px'};
`;

export const NoIcon = styled('div')`
  color: white;
  background: white;
  border: 2px solid ${({ color }) => color};
  border-radius: 12px;
  margin-left: -7px;
  height: 12px;
  width: 12px;
`;

const Item = ({ iconName, iconColor, iconProps = {}, state, title, description, ...props }: TimelineItemProps) => {
  const itemLineColor = state === 'completed' ? '#35a509' : 'orange';
  const itemIconColor = iconColor || itemLineColor;
  return (
    <Box className={`timeline-box ${iconName ? 'with-icon' : ''}`} pl={4} bg="white" {...props}>
      <ItemBox className="timeline-item-box" borderColor={itemLineColor}>
        <Box>
          {iconName ? <ItemIcon name={iconName} color={itemIconColor} size={24} {...iconProps} /> : <NoIcon color={itemLineColor} />}
          <Text pl={7} mt={iconName ? -6 : -4} fontSize="lg" color="greys.charcoal" as="div">
            {title}
          </Text>
          <Text pl={7} fontSize="sm" color="emperor" as="div">
            {description}
          </Text>
        </Box>
      </ItemBox>
    </Box>
  );
};

const Timeline = ({ children }: React.PropsWithChildren<any>) => <TimelineBox>{children}</TimelineBox>;

Timeline.Item = Item;

export default Timeline;
